import React from "react";
import { Panel, PanelTitle, PanelContent } from "@raketa-cms/raketa-mir";

const InputSection = ({ title, children }) => (
  <Panel>
    <PanelTitle>{title}</PanelTitle>
    <PanelContent>{children}</PanelContent>
  </Panel>
);

export default InputSection;
